export function useActivityLog() {
  
  const getCurrentUser = () => {
    try {
     
      const userId = localStorage.getItem('user_id') 
      const username = localStorage.getItem('username')
      
      console.log('📌 Current user:', { userId, username });
      
      return {
        id: userId,
        username: username
      }
    } catch (error) {
      console.error('Error in getCurrentUser:', error);
      return { id: '1', username: 'System User' }
    }
  }

  const generateDescription = (logData) => {
    const tableNames = {
      'customer': 'Kunde',
      'task': 'Auftrag',
      'task_repeat': 'Wiederkehrender Auftrag',
      'tour': 'Tour',
      'stock': 'Lagerbestand',
      'disposal': 'Entsorgung',
      'transport': 'Transport',
      'driver': 'Fahrer',
      'cis_task': 'CIS Auftrag',
      'cis_user': 'CIS Benutzer',
      'conversation': 'Konversation',
    }

    const actionNames = {
      'INSERT': 'erstellt',
      'UPDATE': 'aktualisiert',
      'DELETE': 'gelöscht',
    }

    const tableName = tableNames[logData.table_name] || logData.table_name || 'Eintrag'
    const actionName = actionNames[logData.action] || logData.action || 'bearbeitet'

    return `${tableName} ${actionName}`;
  }

  const getChangedFields = (oldObj, newObj) => {
    if (!oldObj || !newObj) {
      return {
        hasChanges: false,
        changedFields: [],
        oldValues: {},
        newValues: {}
      }
    }

    const changedFields = []
    const oldValues = {}
    const newValues = {}

    const allKeys = new Set([
      ...Object.keys(oldObj),
      ...Object.keys(newObj)
    ])

    allKeys.forEach(key => {
      const oldVal = oldObj[key]
      const newVal = newObj[key]

      if (JSON.stringify(oldVal) !== JSON.stringify(newVal)) {
        changedFields.push(key)
        oldValues[key] = oldVal
        newValues[key] = newVal
      }
    })

    return {
      hasChanges: changedFields.length > 0,
      changedFields: changedFields,
      oldValues: oldValues,
      newValues: newValues
    }
  }

  const logActivity = async (logData, $func) => {

    
    try {
      // Validate $func
      if (!$func || !$func.queryAPI) {

        return { status: 'ERROR', error: '$func not available' };
      }


      const currentUser = getCurrentUser();
 

      // Prepare description
      const description = logData.description || generateDescription(logData);
      console.log('✓ Description:', description);

      // ✅ SIMPLE data object - ensure all values are strings
      const insertData = {
        user_id: String(currentUser.id),
        username: String(currentUser.username),
        action: String(logData.action || ''),
        table_name: String(logData.table_name || ''),
        record_id: String(logData.record_id || ''),
        description: String(description),
      };

      console.log('');
      console.log('📦 Insert data:');
      console.log(JSON.stringify(insertData, null, 2));

      const param = {
        table: "activity_log",
        statement: "insert",
        type: "",
        where: "",
        selector: "",
        value: "",
        extension: ""
      };

      console.log('');
      console.log('🚀 Calling queryAPI...');

      const result = await $func.queryAPI(param, insertData);

      console.log('');
      console.log('✅ Result:');
      console.log(JSON.stringify(result, null, 2));

      if (result && result.status === 'ERROR') {
        console.error('❌ Insert failed:', result.error);
        console.error('SQL:', result.sql);
        return result;
      }

      if (result && result.sql) {
        console.log('');
        console.log('📝 Generated SQL:');
        console.log(result.sql);
        
        // Debug: Check if SQL is empty
        if (result.sql === 'INSERT INTO activity_log () VALUES ()') {
          console.error('⚠️ WARNING: Empty INSERT statement!');
          console.error('This means $func.queryAPI is not recognizing any valid columns.');
          console.error('Insert data keys:', Object.keys(insertData));
          console.error('Insert data values:', Object.values(insertData));
        }
      }


      return result;

    } catch (error) {

      console.error('Error message:', error.message);
      console.error('Error stack:', error.stack);

      return { status: 'ERROR', error: error.message, details: error };
    }
  }

  return {
    logActivity,
    getChangedFields,
    getCurrentUser,
    generateDescription
  }
}